import axios from 'axios'
import type { PeopleSubSections } from 'src/enums'
import { getResponseData } from 'src/queries/network.utils'
import type {
  PostExpenseReportsDownloadRequestParams,
  PostOrgExpenseReportDownloadRequestParams,
  PostReportTransactionsDownloadParams,
  PostReportVirtualCardsDownloadParams,
  ReportDownloadResponse,
} from 'src/queries/reportDownloads/reportDownloads.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getReportDownload = async (
  reportDownloadId: string,
): Promise<ReportDownloadResponse> => {
  return getResponseData(
    axios.get<ReportDownloadResponse>(
      `/reports/${reportDownloadId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postReportTransactionsDownload = async ({
  body,
  qboReport,
  attachments,
  transactionCSVFields,
}: PostReportTransactionsDownloadParams): Promise<ReportDownloadResponse> => {
  return getResponseData(
    axios.post<ReportDownloadResponse>(
      '/reports/transactions/download',
      {
        ...body,
        qboReport,
        attachments,
        transactionCSVFields,
      },
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postReportVirtualCardsDownload = async (
  filters: PostReportVirtualCardsDownloadParams,
): Promise<ReportDownloadResponse> => {
  return getResponseData(
    axios.post<ReportDownloadResponse>(
      '/reports/virtualcards/download',
      filters,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postExpenseReportDownload = async (
  params?: PostExpenseReportsDownloadRequestParams,
): Promise<ReportDownloadResponse> => {
  return getResponseData(
    axios.post<ReportDownloadResponse>(
      '/expensereports/approver/download',
      params,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postOrgExpenseReportDownload = async (
  params: PostOrgExpenseReportDownloadRequestParams,
): Promise<ReportDownloadResponse> => {
  return getResponseData(
    axios.post<ReportDownloadResponse>(
      '/reports/expensereports/download',
      params,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postPeopleDownload = async (
  type: PeopleSubSections,
): Promise<ReportDownloadResponse> => {
  return getResponseData(
    axios.post<ReportDownloadResponse>(
      `/reports/${type}/download`,
      {},
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
